import Page from "../../BaseComponents/Page/Page";
import React, {Fragment} from "react";
import i18n from "../../../i18n";
import {FaSolidIcon} from "../../FontAwesomeIcons";
import WalletView from "../WalletView";
import PropTypes from "prop-types";
import "./../WalletsStyle.css";
import WalletDescription from "../WalletDescription";
import FuxCursorPaginator from "../../BaseComponents/FuxCursorPaginator/FuxCursorPaginator";
import ModalPortalHOC from "../../BaseComponents/ModalPortalHOC";
import ImpagatoModal from "../../Impagati/ImpagatoModal";
import {WalletsAPI} from "../../../api/Wallets/WalletsAPI";
import TransactionView from "./TransactionView";
import {TYPE_WALLET_WELFARE} from "../../CheckoutDiscount/Wallets/WalletsConstants";

export default class SingleWalletPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            walletDescriptionOpen: false,
            transactions: false,
            impagatoModalOpen: false
        };

        const w = this.props.wallet;

        // Background image style (same as WalletView)
        this.backgroundImageStyle = {
            backgroundImage: `url(${w.image_url || ""})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
        };

        // Dark overlay style
        this.overlayDarken = {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.7)",
            zIndex: 0
        };
    }

    toggleWalletDescription = _ => {
        this.setState({walletDescriptionOpen: !this.state.walletDescriptionOpen})
    }

    toggleImpagatoModal = _ => {
        this.setState({impagatoModalOpen: !this.state.impagatoModalOpen})
    }

    handleTransactionRender = transaction => <TransactionView transaction={transaction}/>

    handleTransactionsPageRequest = cursor => WalletsAPI.User.getWalletTransactions(cursor, this.props.wallet.id_wallet)

    //Pagina vuota del fux
    handleTransactionsEmptyPage = _ => ""

    getWalletTitle = _ => {
        switch (this.props.wallet.type) {
            case  TYPE_WALLET_WELFARE:
                return "Il tuo welfare"
            default:
                if (this.props.wallet.name) return this.props.wallet.name.toUpperCase()
                return this.props.wallet.type.replaceAll("_", " ").toUpperCase()
        }
    }


    render() {
        const w = this.props.wallet;

        return (
            <Fragment>
                <Page
                    title={i18n.t("launcher.side-menu.wallets")}
                    leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                    onLeftIconClick={_ => this.props.onDismiss(false)}
                    active={true}
                    content={
                        <div>

                            <div className={"p-3"}>
                                <WalletView
                                    wallet={w}
                                    clickable={false}
                                    showPaymentInfoButton={!!w.impagato}
                                    onPaymentInfoClick={this.toggleImpagatoModal}
                                />
                            </div>

                            <div className={"w-100 text-center mb-2"}>
                                <div
                                    style={{cursor: "pointer"}}
                                    onClick={this.toggleWalletDescription}
                                >
                                    Cosa posso pagare{" "}
                                    {this.state.walletDescriptionOpen
                                        ? <FaSolidIcon name={"caret-down"}/>
                                        : <FaSolidIcon name={"caret-right"}/>}

                                    {this.state.walletDescriptionOpen && (
                                        <WalletDescription
                                            payable_categories={w.payable_categories}
                                            payable_items={w.payable_items}
                                            showCredits={false}
                                        />
                                    )}

                                </div>
                            </div>

                            <FuxCursorPaginator
                                onItemRender={this.handleTransactionRender}
                                onPageRequest={this.handleTransactionsPageRequest}
                                onEmptyPage={this.handleTransactionsEmptyPage}
                            />
                        </div>
                    }
                />

                <ModalPortalHOC>
                    {
                        this.state.impagatoModalOpen &&
                        <ImpagatoModal
                            impagato={w.impagato}
                            onDismiss={this.toggleImpagatoModal}
                        />
                    }
                </ModalPortalHOC>
            </Fragment>
        );
    }
}

SingleWalletPage.propTypes = {
    wallet: PropTypes.object,
    onDismiss: PropTypes.func
}
